(function() {
    $(document).ready(function() {
        const crumb = document.querySelector('.c24BreadCrumbScroll');

        if (crumb) {
            const style = document.createElement('style');
            document.head.appendChild(style);
            const sheet = style.sheet;
            const before = '.c24BreadCrumContainer::before {  width: 10%; }';
            const after = '.c24BreadCrumContainer::after { width: 10%; }';

            const hasScrollableContent = crumb.scrollWidth > crumb.clientWidth;

            // scroll to the right
            crumb.scrollLeft = crumb.scrollWidth;

            // add fadout if there is scrollable content
            if (hasScrollableContent) {
                sheet.insertRule(before, 0);
                sheet.insertRule(after, 1);
            }

            crumb.addEventListener('scroll', function() {
                crumbFadeOut(sheet, false);
            });

            window.addEventListener('resize', function() {
                crumbFadeOut(sheet, true);
            });

            window.addEventListener('orientationchange', function() {
                crumbFadeOut(sheet, true);
            });
        }

        function crumbFadeOut (sheet, scrollToRight) {
            const before = '.c24BreadCrumContainer::before { width: calc(10px + 10%); }';
            const after = '.c24BreadCrumContainer::after { width: calc(10px + 10%); }';
            const hasScrollableContent = crumb.scrollWidth > crumb.clientWidth;

            if (scrollToRight) {
                crumb.scrollLeft = crumb.scrollWidth;
            }

            if (hasScrollableContent) {
            // add fadeout effect when there is scrollable content again
                const crumbVisibleWidth = crumb.offsetWidth;
                const crumbWidth = crumb.scrollWidth;
                const crumbScrollableWidth = crumbWidth - crumbVisibleWidth;
                const crumbScrollableWidthHalf = crumbScrollableWidth / 2;
                const crumbScrollablePercent = crumbScrollableWidthHalf / 100;
                const horizontal = crumb.scrollLeft;
                const horizontalHalf = horizontal / 2;
                const crumbTransparencyFactor = horizontalHalf / crumbScrollablePercent;
                const rulesLength = sheet.cssRules.length;

                if (horizontal < crumbScrollableWidthHalf) {
                    for (let i = 0; i < rulesLength; i++) {
                        sheet.deleteRule(0);
                    }

                    const width = Math.round((crumbTransparencyFactor * 2 / 10));

                    sheet.insertRule('.c24BreadCrumContainer::before {  width: calc(10px + ' + width + '%); }', 0);
                    sheet.insertRule(after, 1);
                } else if (horizontal > crumbScrollableWidthHalf) {
                    for (let i = 0; i < rulesLength; i++) {
                        sheet.deleteRule(0);
                    }
                    const crumbLeftFactor = 100 - crumbTransparencyFactor;
                    const width = Math.round((crumbLeftFactor * 2 / 10));

                    sheet.insertRule(before, 0);
                    sheet.insertRule('.c24BreadCrumContainer::after {  width: calc(10px + ' + width + '%); }', 1);
                }
            } else {
                const rulesLength = sheet.cssRules.length;
                // remove all rules if there is no scrollable content
                for (let i = 0; i < rulesLength; i++) {
                    sheet.deleteRule(0);
                }
            }
        }
    });
})();
